import React, { lazy, Suspense } from 'react';

const LazyForceChangePassword = lazy(() => import('./ForceChangePassword'));

const ForceChangePassword = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode }
) => (
  <Suspense fallback={null}>
    <LazyForceChangePassword {...props} />
  </Suspense>
);

export default ForceChangePassword;
